var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoGoggles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3127 29.9932C26.309 29.9932 26.3053 29.9932 26.3028 29.9932L23.2146 29.9658C22.5753 29.9608 22.0629 29.4372 22.0679 28.7992C22.0729 28.1636 22.5903 27.6525 23.2246 27.6525C23.2283 27.6525 23.232 27.6525 23.2345 27.6525L26.3227 27.6798C26.9619 27.6848 27.4744 28.2084 27.4694 28.8464C27.4632 29.482 26.947 29.9932 26.3127 29.9932Z",
    fill: "#94959B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49426 26.0815C7.22313 26.0815 6.95075 25.987 6.73062 25.793C6.25054 25.3714 6.20452 24.64 6.62614 24.16L16.3869 13.071C16.8085 12.5921 17.5398 12.5449 18.0199 12.9665C18.5 13.3881 18.546 14.1194 18.1243 14.5995L8.36362 25.6885C8.13478 25.9484 7.81638 26.0815 7.49426 26.0815Z",
    fill: "#94959B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4263 27.3902C31.5007 26.4848 36.5763 25.5794 41.6507 24.674C41.6507 24.674 44.8234 35.7841 34.5988 36.3438C34.5988 36.3438 27.3591 36.3811 26.4263 28.8081V27.3902Z",
    fill: "#94959B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5974 37.3398C34.4469 37.3398 32.498 37.3199 30.4272 36.3112C28.4472 35.3486 25.9759 33.2853 25.4386 28.9297L25.4312 28.8688V26.558L42.3607 23.5382L42.6069 24.4026C42.6741 24.6389 44.23 30.2406 41.5174 34.0501C40.0847 36.0612 37.7751 37.1681 34.6521 37.3398L34.6024 37.341C34.6024 37.3398 34.5999 37.3398 34.5974 37.3398ZM27.4211 28.7469C28.2432 35.1347 34.0937 35.3449 34.5737 35.3511C37.0425 35.2105 38.8322 34.3859 39.8931 32.9009C41.5 30.6523 41.1667 27.3738 40.8844 25.8229L27.4211 28.2246V28.7469Z",
    fill: "#94959B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1906 27.3899C18.1163 26.4844 13.0406 25.579 7.96625 24.6736C7.96625 24.6736 4.79352 35.7837 15.0182 36.3434C15.0182 36.3434 22.2579 36.3807 23.1906 28.8077V27.3899Z",
    fill: "#94959B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0203 37.3389C15.0178 37.3389 15.0153 37.3389 15.0141 37.3389L14.9643 37.3377C11.8413 37.166 9.53175 36.0591 8.09899 34.048C5.38643 30.2397 6.94232 24.638 7.00949 24.4005L7.25574 23.5361L24.1865 26.5571V28.8692L24.1791 28.9301C23.643 33.2856 21.1705 35.3489 19.1905 36.3116C17.1197 37.319 15.172 37.3389 15.0203 37.3389ZM8.73328 25.822C8.4522 27.373 8.11888 30.6514 9.72577 32.9C10.7867 34.3851 12.5764 35.2084 15.0452 35.3502C15.5053 35.3452 21.3732 35.145 22.1966 28.746V28.2237L8.73328 25.822Z",
    fill: "#94959B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0067 26.0805C41.6858 26.0805 41.3662 25.9474 41.1374 25.6875L31.3766 14.5985C30.955 14.1184 31.001 13.3883 31.4811 12.9655C31.9599 12.5426 32.6912 12.5898 33.1141 13.0699L42.8748 24.1589C43.2965 24.639 43.2504 25.3691 42.7704 25.792C42.5515 25.986 42.2791 26.0805 42.0067 26.0805Z",
    fill: "#94959B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.999,
    r: 23.9437,
    stroke: "#E1625B",
    strokeWidth: 2.11268
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6892 10.6212L9.18217 43.7198L7.71973 42.1951L42.2268 9.09656L43.6892 10.6212Z",
    fill: "#E1625B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGoggles);
export default __webpack_public_path__ + "static/media/no-goggles.9d130f54f5dd1eecfa7e37c4f9f1bbdd.svg";
export { ForwardRef as ReactComponent };